import { ClipboardList } from "lucide-react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageContainer from "shared/components/pagecontainer/PageContainer";
import { useCompras } from "shared/hooks/useCompras";
import { useVendas } from "shared/hooks/useVendas";
import { formatarNumeroPedido } from "shared/utils/compraStatus";
import { ModalDetalhes } from "shared/components/modal/ModalDetalhes";
import styles from "./DetalhesPedido.module.scss";

interface DetalhesPedidoProps {
  tipo: "compra" | "venda";
}

export const DetalhesPedido: React.FC<DetalhesPedidoProps> = ({ tipo }) => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { compras, loading: carregandoCompras, carregarCompras } = useCompras();
  const { vendas, loading: carregandoVendas } = useVendas();

  useEffect(() => {
    if (tipo === "compra") carregarCompras();
  }, [tipo, carregarCompras]);

  const pedido = tipo === "compra"
    ? compras.find((compra) => compra.id === id)
    : vendas.find((venda) => venda.id === id);

  const carregando = tipo === "compra" ? carregandoCompras : carregandoVendas;

  const itens = tipo === "compra"
    ? (pedido && "itens" in pedido ? pedido.itens ?? [] : [])
    : (pedido && "items" in pedido ? pedido.items ?? [] : []);

  const primeiroItem = itens[0];
  const productId = primeiroItem?.productId ?? "";

  const voltar = () => navigate(tipo === "compra" ? "/minhascompras" : "/minhasvendas");

  return (
    <PageContainer
      title={tipo === "compra" ? "Detalhes da compra" : "Detalhes da venda"}
      icon={<ClipboardList size={18} />}
      showDesktopSearch={false}
      showLogo
      logo={<img src="/imagens/menuLogoBranco.png" alt="Move" />}
    >
      <div className={styles.pagina}>
        {carregando ? (
          <p className={styles.mensagem}>Carregando pedido...</p>
        ) : !pedido ? (
          <div className={styles.mensagem}>
            <ClipboardList size={36} />
            <h2>Pedido não encontrado</h2>
            <p>Não foi possível encontrar esse pedido.</p>
          </div>
        ) : (
          <ModalDetalhes
            modoPagina
            productId={productId}
            orderId={pedido.id}
            itens={itens}
            quantidade={
              primeiroItem && "quantidade" in primeiroItem
                ? primeiroItem.quantidade
                : primeiroItem && "quantity" in primeiroItem
                  ? primeiroItem.quantity
                  : undefined
            }
            valorUnitario={
              primeiroItem && "preco" in primeiroItem
                ? primeiroItem.preco
                : primeiroItem && "unitPrice" in primeiroItem
                  ? primeiroItem.unitPrice
                  : undefined
            }
            valorTotal={pedido.total}
            formaPagamento={pedido.paymentMethod}
            numeroPedido={formatarNumeroPedido(pedido.id)}
            status={pedido.status}
            tipo={tipo}
            onClose={voltar}
          />
        )}
      </div>
    </PageContainer>
  );
};